const Weathers = [
  'Extreme Winters',
  'Mild Winters',
  'Hot + Dry',
  'Hot + Humid',
  'Rainy',
  'Cool and Pleasant',
]

export default Weathers
